export const CHECKOUT_URL = 'https://heavy-equipment-instructor-atlas.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/4QXbmS75dPDEFqfBM2dgVh/Diseno_sin_titulo_(73).png'

export const HERO_IMAGE_ALT =
  'Heavy Equipment Instructor Atlas 6-in-1 box set: 6 professional visual training volumes for heavy equipment instructors'

export const PRIMARY_CTA = 'GET HEAVY EQUIPMENT INSTRUCTOR ATLAS NOW!'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus' | 'extra'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 01 — Forklift & Material Handling Equipment Atlas' },
  { kind: 'included', label: 'Volume 02 — Excavators & Earthmoving Equipment Atlas' },
  { kind: 'included', label: 'Volume 03 — Bulldozers, Loaders & Grading Equipment Atlas' },
  { kind: 'included', label: 'Volume 04 — Cranes, Hoists & Lifting Equipment Atlas' },
  { kind: 'included', label: 'Volume 05 — Aerial Lifts & Elevated Work Platforms Atlas' },
  { kind: 'included', label: 'Volume 06 — Road Construction & Compaction Equipment Atlas' },
  { kind: 'bonus', label: 'Heavy Equipment Instructor Lesson Planning System' },
  { kind: 'bonus', label: 'Heavy Equipment Scenario & Decision-Making Library' },
  { kind: 'bonus', label: 'Heavy Equipment Assessment & Progress Tracking Handbook' },
  { kind: 'bonus', label: 'Heavy Equipment Instructor Question Bank' },
  { kind: 'bonus', label: 'Heavy Equipment Training Debriefing & After-Action Review Manual' },
  { kind: 'extra', label: '100% Visual Main Training System' },
  { kind: 'extra', label: 'Immediate Digital Access' },
  { kind: 'extra', label: 'One-Time Payment' },
]
